import H from "./extends.mjs";
import O from "./objectWithoutPropertiesLoose.mjs";
import * as c from "react";
import { r as j } from "./index173.mjs";
import d from "./index180.mjs";
import { jsx as _ } from "react/jsx-runtime";
import A from "./useEnhancedEffect.mjs";
import P from "./getScrollbarSize.mjs";
import D from "./ownerDocument.mjs";
import V from "./useForkRef.mjs";
import W from "./List.mjs";
const $ = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function v(n, t, r) {
  return n === t ? n.firstChild : t && t.nextElementSibling ? t.nextElementSibling : r ? null : n.firstChild;
}
function M(n, t, r) {
  return n === t ? r ? n.firstChild : n.lastChild : t && t.previousElementSibling ? t.previousElementSibling : r ? null : n.lastChild;
}
function k(n, t) {
  if (t === void 0)
    return !0;
  let r = n.innerText;
  return r === void 0 && (r = n.textContent), r = r.trim().toLowerCase(), r.length === 0 ? !1 : t.repeating ? r[0] === t.keys[0] : r.indexOf(t.keys.join("")) === 0;
}
function b(n, t, r, y, h, w) {
  let p = !1, a = h(n, t, t ? r : !1);
  for (; a; ) {
    if (a === n.firstChild) {
      if (p)
        return !1;
      p = !0;
    }
    const m = y ? !1 : a.disabled || a.getAttribute("aria-disabled") === "true";
    if (!a.hasAttribute("tabindex") || !k(a, w) || m)
      a = h(n, a, r);
    else
      return a.focus(), !0;
  }
  return !1;
}
const C = /* @__PURE__ */ c.forwardRef(function(t, r) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: y,
    autoFocus: h = !1,
    autoFocusItem: w = !1,
    children: p,
    className: a,
    disabledItemsFocusable: m = !1,
    disableListWrap: g = !1,
    onKeyDown: x,
    variant: E = "selectedMenu"
  } = t, L = O(t, $), u = c.useRef(null), S = c.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  A(() => {
    h && u.current.focus();
  }, [h]), c.useImperativeHandle(y, () => ({
    adjustStyleForScrollbar: (e, o) => {
      const l = !u.current.style.width;
      if (e.clientHeight < u.current.clientHeight && l) {
        const f = `${P(D(e))}px`;
        u.current.style[o.direction === "rtl" ? "paddingLeft" : "paddingRight"] = f, u.current.style.width = `calc(100% + ${f})`;
      }
      return u.current;
    }
  }), []);
  const K = (e) => {
    const o = u.current, l = e.key, f = D(o).activeElement;
    if (l === "ArrowDown")
      e.preventDefault(), b(o, f, g, m, v);
    else if (l === "ArrowUp")
      e.preventDefault(), b(o, f, g, m, M);
    else if (l === "Home")
      e.preventDefault(), b(o, null, g, m, v);
    else if (l === "End")
      e.preventDefault(), b(o, null, g, m, M);
    else if (l.length === 1) {
      const s = S.current, F = l.toLowerCase(), I = performance.now();
      s.keys.length > 0 && (I - s.lastTime > 500 ? (s.keys = [], s.repeating = !0, s.previousKeyMatched = !0) : s.repeating && F !== s.keys[0] && (s.repeating = !1)), s.lastTime = I, s.keys.push(F);
      const T = f && !s.repeating && k(f, s);
      s.previousKeyMatched && (T || b(o, f, !1, m, v, s)) ? e.preventDefault() : s.previousKeyMatched = !1;
    }
    x && x(e);
  }, R = V(u, r);
  let i = -1;
  c.Children.forEach(p, (e, o) => {
    if (!/* @__PURE__ */ c.isValidElement(e)) {
      i === o && (i += 1, i >= p.length && (i = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && j.isFragment(e) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), e.props.disabled || (E === "selectedMenu" && e.props.selected || i === -1) && (i = o), i === o && (e.props.disabled || e.props.muiSkipListHighlight || e.type.muiSkipListHighlight) && (i += 1, i >= p.length && (i = -1));
  });
  const N = c.Children.map(p, (e, o) => {
    if (o === i) {
      const l = {};
      return w && (l.autoFocus = !0), e.props.tabIndex === void 0 && E === "selectedMenu" && (l.tabIndex = 0), /* @__PURE__ */ c.cloneElement(e, l);
    }
    return e;
  });
  return /* @__PURE__ */ _(W, H({
    role: "menu",
    ref: R,
    className: a,
    onKeyDown: K,
    tabIndex: h ? 0 : -1
  }, L, {
    children: N
  }));
});
process.env.NODE_ENV !== "production" && (C.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: d.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: d.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: d.node,
  /**
   * @ignore
   */
  className: d.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: d.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: d.bool,
  /**
   * @ignore
   */
  onKeyDown: d.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: d.oneOf(["menu", "selectedMenu"])
});
const ee = C;
export {
  ee as default
};
//# sourceMappingURL=MenuList.mjs.map
